import React from "react";
import {FormContextConsumer} from "../../dynamic-form/dynamic-form-context"

const chooseClassName = (valid, validated) =>{
    if (valid && validated){
        return "form-field-input-default form-field-input--valid"
    }
    else if (!valid && validated){
        return "form-field-input-default form-field-input--invalid"
    }
    else{
        return "form-field-input-default form-field-input"
    }
};

const FormInputField = (props) => {
    const { metadata, valid, validated, format, ...rest } = props;

    return (
        <FormContextConsumer>
            {({ validated: contextValidated }) => (
                <input
                    className={chooseClassName(valid, contextValidated || Boolean(validated))}
                    {...rest}
                />
            )}
        </FormContextConsumer>
    );
};

export default FormInputField;